import {GetterTree} from 'vuex'
import {RootState} from '@/store'
import {
    DistributionChartSection,
    EtlJobsSection,
    ExternalLinksSection,
    LoginAuditChartSection,
    MngCompanyMessageSection,
    TotalsSection
} from '@/models/LobbyDataResponse.model'
import {LobbyDataState} from '@/store/modules/lobby/index'

export const getters: GetterTree<LobbyDataState, RootState> = {

    distributionChartSection(state): DistributionChartSection {
        return state.distributionChartSection
    },

    loginAuditChartSection(state): LoginAuditChartSection {
        return state.loginAuditChartSection
    },

    totalsSection(state): TotalsSection {
        return state.totalsSection
    },

    externalLinksSection(state): ExternalLinksSection {
        return state.externalLinksSection
    },

    mngCompanyMessageSection(state): MngCompanyMessageSection {
        return state.mngCompanyMessageSection
    },

    etlJobsSection(state): EtlJobsSection {
        return state.etlJobsSection
    }
}